    // File: src/components/CareersSection.tsx

    import React from "react";
    import { motion } from "framer-motion";
    import "../styles/CareersSection.css";
    import { Link } from "react-router-dom";
    import { Link as ScrollLink } from "react-scroll";

    const textVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
        opacity: 1,
        y: 0,
        transition: { duration: 0.6, ease: "easeOut" },
    },
    };

    const buttonVariants = {
    hidden: { opacity: 0, scale: 0.95 },
    visible: (i: number) => ({
        opacity: 1,
        scale: 1,
        transition: { delay: 0.3 + i * 0.2, duration: 0.5, ease: "easeOut" },
    }),
    };

    const CareersSection: React.FC = () => {
    return (
        <section className="careers-section">
        <motion.h1
            className="title"
            initial="hidden"
            animate="visible"
            variants={textVariants}
        >
            Careers at <span className="highlight">NexaGrowth Africa</span>
        </motion.h1>

        <motion.p
            className="description"
            initial="hidden"
            animate="visible"
            variants={textVariants}
        >
            Join a team that's building the future. We're looking for passionate
            individuals who want to make a meaningful impact and grow their careers
            with us.
        </motion.p>

        <div className="button-group">
            <ScrollLink to="jobs" smooth={true} duration={500} offset={-50} className="link-text">
            <motion.button
            className="primary-btn"
            initial="hidden"
            animate="visible"
            custom={0}
            variants={buttonVariants}
            >
            View Open Positions
            </motion.button>
            </ScrollLink>
            <Link to= "/about" className="link-text">
            <motion.button
            className="secondary-btn"
            initial="hidden"
            animate="visible"
            custom={1}
            variants={buttonVariants}
            >
            Learn more
            </motion.button>
            </Link>
        </div>
        </section>
    );
    };

    export default CareersSection;